import type {
  TValuesCurrentBlocks,
  TValuesCurrentIrrigationZones,
  TValuesCurrentPoints,
  TValuesCurrentProperties,
  TValuesCurrentRegions,
  TValuesTimeseriesBlocks,
  TValuesTimeseriesIrrigationZones,
  TValuesTimeseriesPoints,
  TValuesTimeseriesProperties,
  TValuesTimeseriesRegions,
} from 'App/Map/types'

type TGenericValuesCurrent =
  | TValuesCurrentBlocks
  | TValuesCurrentIrrigationZones
  | TValuesCurrentPoints
  | TValuesCurrentProperties
  | TValuesCurrentRegions
  | '_metaData'

type TGenericValuesTimeseries =
  | TValuesTimeseriesBlocks
  | TValuesTimeseriesIrrigationZones
  | TValuesTimeseriesPoints
  | TValuesTimeseriesProperties
  | TValuesTimeseriesRegions

type TGenericFieldAssetRecord = unknown & {
  // Optional because the API does not guarantee these arrays are present on
  // every field asset. Declaring them as required let an unguarded
  // `.includes()` through to production (BANYAN_APP-4ZR).
  valuesCurrent?: TGenericValuesCurrent[]
  valuesTimeseries?: TGenericValuesTimeseries[]
}

/**
 * Returns field assets that have ANY of the provided value types
 *
 */
export const filterFieldAssetsByValueTypes = <T extends TGenericFieldAssetRecord[]>({
  fieldAssets,
  valuesCurrent,
  valuesTimeseries,
}: {
  fieldAssets: T
  valuesCurrent?: TGenericValuesCurrent[]
  valuesTimeseries?: TGenericValuesTimeseries[]
}): T => {
  if (valuesCurrent && valuesCurrent.length) {
    return fieldAssets.filter((fa) => valuesCurrent.some((vc) => fa.valuesCurrent?.includes(vc))) as T
  }

  if (valuesTimeseries && valuesTimeseries.length) {
    return fieldAssets.filter((fa) => valuesTimeseries.some((vc) => fa.valuesTimeseries?.includes(vc))) as T
  }

  return fieldAssets
}
